import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Intent, InputGroup, TextArea } from '@blueprintjs/core';
import { Row, Col } from 'reactstrap';
import moment from 'moment';
import { IconNames } from '@blueprintjs/icons';
import { createForm } from 'rc-form';
import styled from 'styled-components';

import SelectFacility from 'components/elements/select-facility';
import SelectTinhTrangThanhTra from 'components/elements/select-tinh-trang-thanh-tra';
import NumericInput from 'components/elements/numeric-input';
import DateInput from 'components/elements/date-input';
import DateRangeInput from 'components/elements/date-range-input';

import IconRequired from 'components/elements/required-icon';
import { DATE_FORMAT, COLOR } from 'config';
import Clearfix from 'components/elements/clearfix';
import { convertDateFromSever as convertDate } from 'utils/fnUtil';
// import dynamicRoleHOC from 'hoc/dynamicRole';

const LabelContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-end;
`;

const HeaderContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-start;
  cursor: pointer;
`;

const ErrorContainer = styled.div`
  margin-top: 5px;
  color: #5c7080;
  font-size: 12px;
  color: red;
`;

// @dynamicRoleHOC()
class InspectionFormChild extends React.Component {
  static propTypes = {
    isEdit: PropTypes.bool,
    initialValue: PropTypes.object,
    slugBack: PropTypes.string,
    onSubmit: PropTypes.func,
  };

  setInitialValue(keyPath, defaultValue, type = '') {
    let value = _.result(this.props.initialValue, keyPath, defaultValue);
    if (value) {
      switch (type) {
        case 'select':
          return {
            value: value._id,
            label: value.Name ? value.Name : value.FacilityNameFull,
          };
        case 'date':
          return moment(value).format(DATE_FORMAT);
        case 'dates':
          return `${moment(value[0]).format(DATE_FORMAT)} - ${moment(
            value[1]
          ).format(DATE_FORMAT)}`;
        default:
      }
    }
    return value;
  }

  submit = () => {
    this.props.form.validateFields((error, value) => {
      if (error) return;
      if (value.status) {
        value.status = _.get(value, 'status.value', null);
      }

      if (value.Facility) {
        delete value.Facility;
      }
      if (this.props.onSubmit) this.props.onSubmit(value);
    });
  };

  render() {
    const { getFieldProps, getFieldError } = this.props.form;

    return (
      <div>
        <h4
          className='bp3-heading'
          style={{
            color: COLOR.SUCCESS,
          }}
        >
          Kế hoạch thanh tra
        </h4>
        <Row>
          <Col xs={4}>
            <HeaderContainer>
              <Icon
                icon={IconNames.SAVED}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.PRIMARY}
                onClick={this.submit}
                style={{color: COLOR.SUCCESS}}
              />
              <Clearfix width={8} />
              {/* <Link to={this.props.slugBack ? this.props.slugBack : slug.BASE}> */}
              <Icon
                onClick={() => {
                  window.history.back();
                }}
                icon={IconNames.DISABLE}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.DANGER}
              />
              {/* </Link> */}
            </HeaderContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Trạng thái thanh tra</LabelContainer>
          </Col>
          <Col xs={4}>
            <SelectTinhTrangThanhTra
              hideLabel
              fieldForm={{
                form: this.props.form,
                name: 'status',
                option: {
                  initialValue: this.setInitialValue('status', null, 'select'),
                },
              }}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
              <b>Kế hoạch thanh tra</b>
            </LabelContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
            Tên cơ sở/dự án
              <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <SelectFacility
              isDisabled={true}
              hideLabel
              fieldForm={{
                form: this.props.form,
                name: 'Facility',
                option: {
                  initialValue: this.setInitialValue(
                    'Facility',
                    null,
                    'select'
                  ),
                },
              }}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
              Số quyết định đoàn thanh tra
              <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              disabled
              placeholder='Số quyết định đoàn thanh tra'
              value={this.setInitialValue(
                'facilityInspection.InspectionNumber',
                ''
              )}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
              Thời gian thanh tra <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <DateRangeInput
              fill={true}
              disabled
              singleMonthOnly={true}
              shortcuts={false}
              formatDate={(date) => moment(date).format(DATE_FORMAT)}
              parseDate={(str) => moment(str).toDate()}
              value={[
                convertDate(
                  this.setInitialValue('facilityInspection.InspectionDate')
                    ? this.setInitialValue(
                        'facilityInspection.InspectionDate'
                      )[0]
                    : null
                ),
                convertDate(
                  this.setInitialValue('facilityInspection.InspectionDate')
                    ? this.setInitialValue(
                        'facilityInspection.InspectionDate'
                      )[1]
                    : null
                ),
              ]}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Ngày ra quyết định</LabelContainer>
          </Col>
          <Col xs={4}>
            <DateInput
              fill={true}
              disabled
              formatDate={(date) => moment(date).format(DATE_FORMAT)}
              parseDate={(str) => moment(str).toDate()}
              placeholder='Ngày ra quyết định'
              value={convertDate(
                this.setInitialValue('facilityInspection.DecideDate', null)
              )}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Cơ quan ban hành</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              disabled
              placeholder='Cơ quan ban hành'
              value={this.setInitialValue(
                'facilityInspection.AgencyIssued',
                ''
              )}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Ghi chú kế hoạch thanh tra</LabelContainer>
          </Col>
          <Col xs={4}>
            <TextArea
              fill
              {...getFieldProps('InspectionNote', {
                initialValue: this.setInitialValue('InspectionNote', null),
              })}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
              <b>Kết luận thanh tra</b>
            </LabelContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Số kết luận thanh tra</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Số kết luận thanh tra'
              {...getFieldProps('ConcludeNumber', {
                initialValue: this.setInitialValue('ConcludeNumber', ''),
              })}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Tên kết luận thanh tra</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Tên kết luận thanh tra'
              {...getFieldProps('ConcludeName', {
                initialValue: this.setInitialValue('ConcludeName', ''),
              })}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Kết luận thanh tra</LabelContainer>
          </Col>
          <Col xs={4}>
            <TextArea
              fill
              {...getFieldProps('ConcludeDesc', {
                initialValue: this.setInitialValue('ConcludeDesc', null),
              })}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
              <b>Xử lý vi phạm hành chính</b>
            </LabelContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Số quyết định xử phạt</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Số quyết định xử phạt'
              {...getFieldProps('FinedNumber', {
                initialValue: this.setInitialValue('FinedNumber', ''),
              })}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Tên quyết định xử phạt</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Tên quyết định xử phạt'
              {...getFieldProps('FinedName', {
                initialValue: this.setInitialValue('FinedName', ''),
              })}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Cơ quan ra quyết định</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Cơ quan ra quyết định'
              {...getFieldProps('FinedAgency', {
                initialValue: this.setInitialValue('FinedAgency', ''),
              })}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Ngày quyết định</LabelContainer>
          </Col>
          <Col xs={4}>
            <DateInput
              fill={true}
              formatDate={(date) => moment(date).format(DATE_FORMAT)}
              parseDate={(str) => moment(str).toDate()}
              placeholder='Ngày quyết định'
              {...getFieldProps('FinedDate', {
                initialValue: convertDate(
                  this.setInitialValue('FinedDate', null)
                ),
              })}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Tiền phạt</LabelContainer>
          </Col>
          <Col xs={4}>
            <NumericInput
              fill
              placeholder='Tiền phạt'
              {...getFieldProps('FinedMoney', {
                initialValue: this.setInitialValue('FinedMoney', ''),
                rules: [
                 
                ],
              })}
            />
             <ErrorContainer>
              {(getFieldError('FinedMoney') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Ghi chú</LabelContainer>
          </Col>
          <Col xs={4}>
            <TextArea
              fill
              {...getFieldProps('FinedNotes', {
                initialValue: this.setInitialValue('FinedNotes', null),
              })}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default createForm()(InspectionFormChild);



// WEBPACK FOOTER //
// ./src/containers/Inspection/InspectionFormChild/index.js